module.exports = __webpack_public_path__ + "img/CM-SS-25-Ford-Established.e9f86298.jpg";